import React from "react";
import { CloseOutlined } from "@ant-design/icons";
interface AnnouncementPopupProps {
  title: string;
  content: string;
  logo: string; 
  icon: string;
  buttonText: string;
  onClose?: () => void;
  onButtonClick?: () => void;
}

const AnnouncementPopup: React.FC<AnnouncementPopupProps> = ({
  title,
  content,
  logo,
  icon,
  buttonText,
  onClose,
  onButtonClick,
}) => {
  return (
    <div className="email-status-popup">
      <div className="popup-card">
        {/* Close button */}
        {onClose && (
          <button className="close-btn" onClick={onClose} aria-label="Close">
            <CloseOutlined />
          </button>
        )}

        {/* Logo + icon inline like EmailStatusPopup */}
        <div className="logo-row">
          <img src={icon} alt="Popup Icon" className="popup-icon" />
          <img src={logo} alt="Announcement Logo" className="popup-logo" />
        </div>

        {/* Divider */}
        <div className="popup-divider" />

        {/* Title */}
        <h2 className="popup-title">{title}</h2>

        {/* Content */}
        <div className="announcement-content">
          <p>{content}</p>
        </div>

        {/* Action button */}
        <button className="popup-btn" onClick={onButtonClick}>
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default AnnouncementPopup;
